import './footnotes.js';
import './scroll-dim.js';
import './sidebar-gradient.js';

console.log('Whole Earth Redux');